<template lang="pug">
  .width-100
    .users-header.row.middle
      button.row.middle.pointer(@click='$emit("selectAll")')
        checkbox(white :checked='selectedUsers.length === users.length')
        h2.text-normal.white.m-left-1 {{ $t("shareResource.selectAll") }}
      button.row.middle.m-left-auto(v-if='!withoutGroups' @click='showCreateSharingGroupModal')
        simple-svg.white-icon.m-right-05(:filepath='plusIcon' width='18px' height='18px')
        h2.text-normal.white.m-right-1 {{ $t("shareResource.createGroup") }}
    .users.kimple-scroll.column.width-100
      .loader.row.middle.center(v-if='loading')
        loader(size='inner')
      slot(v-else)
</template>

<script>
import checkboxFilled from '@/assets/ic_checkbox_active_transparent.svg'
import checkboxUnfilled from '@/assets/ic_checkbox_default_transparent.svg'
import plusIcon from '@/assets/ic_circle-add.svg'
import Loader from '@/components/Loader'
import Checkbox from '@/components/Inputs/Checkbox'
import { mapActions } from 'vuex'

export default {
  components: { Loader, Checkbox },
  props: {
    users: { type: Array },
    selectedUsers: { type: Array },
    loading: { type: Boolean },
    source: { type: String },
    sourceProps: { type: Object },
    withoutGroups: { type: Boolean }
  },
  data() {
    return {
      plusIcon,
      checkboxFilled,
      checkboxUnfilled
    }
  },
  methods: {
    ...mapActions([
      'showElement',
      'hideElement'
    ]),
    showCreateSharingGroupModal() {
      this.hideElement({ element: this.source, props: this.sourceProps })
      this.showElement({ element: 'createSharingGroupModal', props: { source: this.source, sourceProps: this.sourceProps } })
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';

.users-header{
  background-color: $blue;
  border-radius: 5px 5px 0 0;
  padding: 12px;
}

.loader{
  height: 500px;
  width: 100%;
}

.users {
  margin-bottom: 30px;
  height: 300px;
  overflow-y: scroll;

  &>:nth-child(even){
    background-color: $light-gray;
  }
}
</style>
